// extracted by mini-css-extract-plugin
export var home__clipContainer = "homeClip-module--home__clipContainer--Q2Qnw";